import { DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import styles from "./dashboard.module.css";
import { ArrowLeft, X } from "react-feather";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import NumberFormat from "react-number-format";

const MoneyField = (props) => {
    return (
        <NumberFormat
            prefix=""
            displayType="input"
            type="text"
            thousandSeparator={true}
            allowNegative={false}
            decimalScale={2}
            fixedDecimalScale
            {...props}
        />
    );
};

const schema = yup.object().shape({
    offer: yup.string().required("This field is Required"),
    rent_adjustment: yup.string(),
    new_rent_amount: yup.boolean().when("rent_adjustment", (rent_adjustment) => {
        if (rent_adjustment && parseInt(rent_adjustment) === 2)
            return yup.string().required("This field is Required").test("non-zero-validate", "This field should be $1 or greater.", (value) => parseInt(value) > 0);
        else
            return yup.string();
    }),
    new_security_deposit: yup.boolean().when("rent_adjustment", (rent_adjustment) => {
        if (rent_adjustment && parseInt(rent_adjustment) === 2)
            return yup.string().required("This field is Required").test("non-zero-validate", "This field should be $1 or greater.", (value) => parseInt(value) > 0);
        else
            return yup.string();
    }),
});

const RenewalForm = ({ setOpenRenewalFormModal, showConfirmBox, selectedTenants }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [allTemaplteList, setAllTemaplteList] = useState([]);
    const [temaplteList, setTemaplteList] = useState([]);
    const [rentAdjustment, setRentAdjustment] = useState(0);

    const { register, handleSubmit, control, errors, setValue } = useForm({
        resolver: yupResolver(schema),
        mode: "onChange",
        defaultValues: {
            offer: ''
        }
    });

    useEffect(() => {
        const fetchTemplates = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            axios(process.env.REACT_APP_PAYMENT_API_URL + "v1/lease-renewal/template", {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setAllTemaplteList(response.data.data?.filter(i => i?.is_archived === 0));
            }).catch((error) => { });
        }
        fetchTemplates();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        let temaplteListTemp = [];

        if (selectedTenants?.length > 1) {
            temaplteListTemp = allTemaplteList?.filter(i => i?.rent_adjustment === 1);
            setValue('offer', temaplteListTemp[0]?.id);
            setValue('rent_adjustment', 1);
            setRentAdjustment(1);
        } else {
            temaplteListTemp = [...allTemaplteList];
        }

        setTemaplteList(temaplteListTemp);
    }, [allTemaplteList, selectedTenants]);



    const onSubmit = async (data) => {
        if (parseInt(data?.rent_adjustment) === 1) {
            data = { ...data, new_rent_amount: 0, new_security_deposit: 0 }
        }
        if (parseInt(data?.rent_adjustment) === 2) {
            data = { ...data, new_rent_amount: data?.new_rent_amount?.replace(/,/g, ""), new_security_deposit: data?.new_security_deposit?.replace(/,/g, "") }
        }
        showConfirmBox(data);
    }

    return (<>
        <DialogTitle id="alert-dialog-title">
            <button className={`${styles.BackAddBU}`} onClick={(e) => setOpenRenewalFormModal(false)}><ArrowLeft /></button>
            <span>Send Renewal Offer</span>
            <button onClick={(e) => setOpenRenewalFormModal(false)}><X /></button>
        </DialogTitle>
        <DialogContent>
            <div className={`${styles.ProfileCardEditSec}`}>
                <p className={`${styles.OfferTemplatePopupText}`}>You’re about to send a renewal offer to the selected tenants. Choose an offer template and review the details before sending.</p>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <input type="hidden" name="rent_adjustment" ref={register} />
                    <div className={`${styles.ProfileEditFormSec}`}>
                        <div className={`${styles.EditFormFullSec} FormGroup`}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Choose Offer Template*</InputLabel>
                                <Controller
                                    name="offer"
                                    control={control}
                                    render={(field) => (
                                        <Select
                                            {...field}
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            label="Choose Offer Template*"
                                            onChange={(e) => {
                                                field.onChange(e);

                                                let selOffer = temaplteList?.filter(i => i?.id === e.target.value);
                                                if (selOffer.length) {
                                                    setRentAdjustment(selOffer[0]?.rent_adjustment);
                                                    setValue('rent_adjustment', selOffer[0]?.rent_adjustment);
                                                }

                                            }}
                                        >
                                            {temaplteList?.map(i => {
                                                return <MenuItem value={i?.id}>{i?.title}</MenuItem>
                                            })}
                                        </Select>
                                    )}
                                />
                            </FormControl>
                            {errors.offer && (<p className={`${styles.ErrorM}`}>{errors.offer.message}</p>)}
                            {rentAdjustment === 1 && <p className={`${styles.HelpTextFormField}`}>Tenants will retain their existing rent with no changes.</p>}
                            {rentAdjustment === 2 && <p className={`${styles.HelpTextFormField}`}>Set a new rent amount for the selected tenants.</p>}
                        </div>
                        {rentAdjustment === 2 && <>
                            <div className={`${styles.EditFormHalfSec} FormGroup`}>
                                <Controller
                                    name="new_rent_amount"
                                    control={control}
                                    render={(props) => (
                                        <TextField
                                            {...props}
                                            id="outlined-basic"
                                            label="New Rent Amount*"
                                            InputProps={{ inputComponent: MoneyField }}
                                        />
                                    )}
                                />
                                {errors.new_rent_amount && (<p className={`${styles.ErrorM}`}>{errors.new_rent_amount.message}</p>)}
                            </div>
                            <div className={`${styles.EditFormHalfSec} FormGroup`}>
                                <Controller
                                    name="new_security_deposit"
                                    control={control}
                                    render={(props) => (
                                        <TextField
                                            {...props}
                                            id="outlined-basic"
                                            label="Additional Security Deposit*"
                                            InputProps={{ inputComponent: MoneyField }}
                                        />
                                    )}
                                />
                                {errors.new_security_deposit && (<p className={`${styles.ErrorM}`}>{errors.new_security_deposit.message}</p>)}
                            </div>
                        </>}
                    </div>
                    <div className={`${styles.ButtonArea}`}>
                        <button className={`${styles.ButtonVoiletLine}`} type="button" onClick={(e) => setOpenRenewalFormModal(false)}>Cancel</button>
                        <button className={`${styles.ButtonVoiletSolid}`} type="submit">Send</button>
                    </div>
                </form>
            </div >
        </DialogContent >
    </>)
}


export default RenewalForm;